<template>
    <div class="flex items-center justify-center rounded-full">
        <DsIcon
            icon="fa-regular fa-cloud-arrow-up"
            size="xl"
        />
    </div>

    <slot name="dropzoneText">
        <div class="text-center text-content-lg font-medium text-content-primary">
            {{ text }}
        </div>
    </slot>

    <div class="text-content-md font-normal text-content-secondary">or</div>

    <DsButton
        class="mt-2"
        :disabled
        size="sm"
        variant="secondary"
        @click.stop="triggerFilePicker"
    >
        <slot name="buttonText">Select documents</slot>
    </DsButton>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import DsButton from '@ds/button/DsButton.vue';

defineProps<{
    text: string;
    disabled?: boolean;
    triggerFilePicker: () => void;
}>();

defineSlots<{
    dropzoneText: () => void;
    buttonText: () => void;
}>();
</script>
